import React, { useEffect, useState } from "react";
import { EditOutlined, PlusOutlined, TrophyOutlined } from "@ant-design/icons";
import { Button, Checkbox, Space, Table, message } from "antd";
import { Alert, Snackbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import AddStudentHistoryForm from "../../components/forms/StudentAcadamicHistoryForm";
import SchoolIcon from "@mui/icons-material/School";
import { fetchAllAcadamicHistory } from "../../store/studentHistorySlice";
import useTokenExpiryCheck from "../../utils/UseTokenExpiryCheck";
import { API_BASE_URL } from "../../config";
import AccessDenied from '../../hooks/AccessDenied'; // Adjust the import path

const StudentAcadamicHistoryInfo = () => {
  const studentHistoy = useSelector((state) => state.studentHistory);
  
  const { studentHistoyList, loading } = studentHistoy;
  const userInfoString = JSON.parse(localStorage.getItem("userInfo"));
  const storedToken = userInfoString?.token;
  const [editingAcadamicHistory, setEditingAcadamicHistory] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);

  if (!userInfoString) {
    throw new Error("No user data or token found");
  }
const isStudent = userInfoString?.roles?.includes("Student") ? true : false;

  //  console.log("studentHistoyList", studentHistoy);
  const dispatch = useDispatch();

  useTokenExpiryCheck();

  // console.log("studentHistoyList", studentHistoy);

  useTokenExpiryCheck();

  useEffect(() => {
    dispatch(fetchAllAcadamicHistory());
    //    console.log("studentHistoyList", studentHistoyList);
  }, [dispatch]);


  const handleEditStudentHistory = (record) => {
    setEditingAcadamicHistory(record);
    setIsModalOpen(true);
  };
  const handleAddModalOpen = () => {
    setIsModalOpen(true); // Open add modal
  };

  const onSave = () => {
    setSuccess(true);
    setIsModalOpen(false);
    dispatch(fetchAllAcadamicHistory());
  };
  const onCancel = () => {
    setIsModalOpen(false);
  };

  const onSaveFail = (message) => {
    setError(message);
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "studentHistoryId",
      key: "studentHistoryId",
    },
    {
      title: "School Name",
      dataIndex: "schoolName",
      key: "schoolName",
    },
    {
      title: "Grade From",
      dataIndex: "gradeFrom",
      key: "gradeFrom",
    },
    {
      title: "Grade To",
      dataIndex: "gradeTo",
      key: "gradeTo",
    },
    {
      title: "Entry Date",
      dataIndex: "entryDate",
      key: "entryDate",
    },
    {
      title: "Exit Date",
      dataIndex: "exitDate",
      key: "exitDate",
    },
    {
      title: "School Phone Number",
      dataIndex: "schoolPhoneNumber",
      key: "schoolAddress",
    },
    {
      title: "School Address",
      dataIndex: "schoolAddress",
      key: "schoolAddress",
    },
    {
      title: "Certificate",
      dataIndex: "document",
      key: "document",
      render: (text, record) =>
        record.document ? (
          <img
            src={`data:image/png;base64,${record.document}`} // Adjust the MIME type (image/png) based on your actual data
            alt="document"
            style={{ width: "50px", height: "auto" }} // Adjust size as necessary
          />
        ) : (
          <span>No Certificate</span>
        ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEditStudentHistory(record)}
          >
            Edit History
          </Button>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleDeleteStudentHistory(record)}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];
  const handleDeleteStudentHistory = async (values) => {
    try {
      const StudentHistoryId = values.studentHistoryId;
      //     console.log("values", values);
      //      console.log("StudentHistoryId", StudentHistoryId);
      const response = await fetch(
        `${API_BASE_URL}/api/StudentHistory/PermanentDelete/${StudentHistoryId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      if (!response.ok) {
        setError("Failed to delete health issue");
      }

      dispatch(fetchAllAcadamicHistory());
      message.success("Health issue deleted successfully!");
      setSuccess(true);
    } catch (error) {
      setError(error.message || "Something went wrong");
    }
  };
  // if (!isStudent) {
  //   return <AccessDenied />;
  // }  
  return (
    <div className="flex">
      <div className="grow-0">
        <div className="p-4">
          <div className="flex justify-between items-center m-4 mt-0">
            <h2 className="text-2xl font-bold">
              <SchoolIcon style={{ marginRight: 8 }} />
              Academic History
            </h2>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAddModalOpen}
            >
              Add Student History
            </Button>
          </div>
          <Table
            columns={columns}
            dataSource={studentHistoyList}
            loading={loading}
          />
          {isModalOpen && (
            <AddStudentHistoryForm
              onSave={onSave}
              onSaveFail={onSaveFail}
              open={isModalOpen}
              onCancel={onCancel}
              initialValues={editingAcadamicHistory}
              mode={editingAcadamicHistory ? "edit" : "create"}
            />
          )}
          <Snackbar
            open={success}
            autoHideDuration={6000}
            onClose={() => setSuccess(false)}
          >
            <Alert
              onClose={() => setSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              Changes saved successfully!
            </Alert>
          </Snackbar>
          <Snackbar
            open={!!error}
            autoHideDuration={6000}
            onClose={() => setError(null)}
          >
            <Alert
              onClose={() => setError(null)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {error}
            </Alert>
          </Snackbar>
        </div>
      </div>
    </div>
  );
};

export default StudentAcadamicHistoryInfo;
